import React from 'react';
import {useState} from 'react';
import './RegisterPage.css';
import ContactInfo from './components/ContactInfo';
import EduInfo from './components/EduInfo';
import Header from '../../common_components/Header';
import LoadingScreen from './components/LoadingScreen';
import PersonalInfo from './components/PersonalInfo';
import Register from './components/Register';
import WorkInfo from './components/WorkInfo';
import FormState from './context/FormState';
import Footer from '../../common_components/Footer';
import ConnectWithUs from '../../common_components/ConnectWithUs';
function RegisterPage() {
  const [step,setStep]=useState("1");
  const [salutation,setSalutation]=useState("");
  const [first,setFirst]=useState("");
  const [last,setLast]=useState("");
  const [gender,setGender]=useState("");
  const [dob,setDOB]=useState("");
  const [imageupload,setImage] = useState('');
  const [university,setUniversity]=useState('');
  const [degree,setDegree]=useState('');
  const [eduFrom,setEduFrom]=useState('');
  const [eduTo,setEduTo]=useState('');
  const [contact,setContact]=useState('');
  const [linkedin,setLinkedin]=useState('');
  const [country,setCountry]=useState('');
  const [state,setState]=useState('');
  const [address,setAddress]=useState('');
  const [pincode,setpincode]=useState('');
  const [headline,setHeadline]=useState('');
  const [position,setPosition]=useState('');
  const [company,setCompany]=useState('');
  const [designation,setDesignation]=useState('');
  const [workFrom,setWorkFrom]=useState('');
  const [workTo,setWorkTo]=useState('');
  const [location,setLocation]=useState('');
  const [isLoading,setIsLoading]=useState(false);
  var content;
  if(isLoading) content=<LoadingScreen></LoadingScreen>;
  else if(step=="1")content=<Register setStep={setStep}></Register>
  else if(step=="2")content=<PersonalInfo setStep={setStep}></PersonalInfo>;
  else if(step=="3")content=<EduInfo setStep={setStep}></EduInfo>;
  else if(step=="4")content=<ContactInfo setStep={setStep}></ContactInfo>;
  else if(step=="5")content=<WorkInfo setStep={setStep}></WorkInfo>;
  else if(step=="6")content=<div>Registraion Process finished.This is just a placeholder for the content that has to be displayed after the registration process completes.</div>
 
  return (
    <FormState.Provider 
    value={{
      salutation:salutation,setSalutation:setSalutation,
      first:first,setFirst:setFirst,
      last:last,setLast:setLast,
      gender:gender,setGender:setGender,
      dob:dob,setDOB:setDOB,
      imageupload:imageupload,setImage:setImage,
      university:university,setUniversity:setUniversity,
      degree:degree,setDegree:setDegree,
      eduFrom:eduFrom,setEduFrom:setEduFrom,
      eduTo:eduTo,setEduTo:setEduTo,
      contact:contact,setContact:setContact,
      linkedin:linkedin,setLinkedin:setLinkedin,
      country:country,setCountry:setCountry,
      state:state,setState:setState,
      address:address,setAddress:setAddress,
      pincode:pincode,setpincode:setpincode,
      headline:headline,setHeadline:setHeadline,
      position:position,setPosition:setPosition,
      company:company,setCompany:setCompany,
      designation:designation,setDesignation:setDesignation,
      workFrom:workFrom,setWorkFrom:setWorkFrom,
      workTo:workTo,setWorkTo:setWorkTo,
      location:location,setLocation:setLocation,
      isLoading:isLoading,setIsLoading:setIsLoading

    }}>
      <React.Fragment>
        {content}
      </React.Fragment>
    </FormState.Provider>
    
  );
}

export default RegisterPage;
